import { type SupabaseDatabase } from "../../supabase";

type SPBFunctionReturns<Fn extends keyof SupabaseDatabase["public"]["Functions"]> =
  SupabaseDatabase["public"]["Functions"][Fn]["Returns"] extends readonly (infer R)[]
    ? R
    : SupabaseDatabase["public"]["Functions"][Fn]["Returns"];

export type TemplateVersionStatus = SupabaseDatabase["hub_reports"]["Enums"]["version_status"];

export type TemplatesTable = SPBFunctionReturns<"get_templates">;
export type VersionsTable = SPBFunctionReturns<"get_versions_by_template_id">;
export type VersionHistory = SPBFunctionReturns<"get_events_by_version_id">;
export type CreateDraftReturn = SPBFunctionReturns<"create_draft_version">;

// Copied each tool's `keyPrefix` because an import brings the whole code of the toolsinto the chunk
export const TOOLS_BINDINGS = {
  null: null,
  portfolio: "comprehensive.portfolioInsights",
  largeSite: "comprehensive.largeSite",
} as const;

export const getCollectionToolBinding = (isLargeSite: boolean) =>
  isLargeSite ? TOOLS_BINDINGS.largeSite : TOOLS_BINDINGS.portfolio;

export const TOOL_OPTIONS = [
  { value: TOOLS_BINDINGS.largeSite, label: "Large Site Analysis" },
  { value: TOOLS_BINDINGS.portfolio, label: "Portfolio" },
];

export const BLANK_TOOL_OPTION = { value: "blank", label: "Blank" };
